import "core-js/modules/es.array.push.js";
import { $h, Tips, basePost, baseTokenPost, U, baseGet, URL, SplitArray, urlParams } from '@/utils/util.js';
import zrcheader from '@/components/zrcheader/index.vue';
import zrcfooter from '@/components/zrcfooter/index.vue';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
export default {
  name: 'ProjectdetailView',
  components: {
    zrcheader,
    zrcfooter
  },
  data() {
    return {
      zrctoken: '',
      userinfo: {
        xingming: '',
        uid: 0
      },
      //用户信息

      current: 1,
      //当前菜单按钮的数字

      chongzhi_list: [],
      //充值明细列表
      koufei_list: [],
      //消费明细列表
      dingdan_list: [],
      //订单列表

      bkid: 0,
      bkidinfo: [],
      info: [],
      xiangmulist: [],
      bklist_pc: [],
      bkid_name: '',
      showsfinfo: 0,
      showyichangtp: 1,
      //弹屏异常提示
      yichanglist: [],
      taptxt_title: '',
      taptxt_deso: '',
      show_paymoney_tanp: 0,
      //输入支付金额开关
      dqxztitle: '',
      //当前选中的缴费的标题
      dqjfid: 0,
      //当前选中的缴费ID
      paymoney: 0,
      //填写的支付金额
      tlzfinfo: [],
      //通联支付的数据

      show_payerweima_tanp: 0,
      bkjflist: [],
      //报考缴费列表

      cusinfo: [],
      //客户信息

      loadingStatus: true,
      xzmenu: 6 //菜单选中
    };
  },
  created() {
    var that = this;
    this.getParams();
    setTimeout(() => {
      this.loadingStatus = false;
    }, 2000);
  },
  onLoad(option) {
    console.log('参数');
  },
  watch: {
    '$route'(to, from) {
      // 在mounted函数执行的方法，放到该处
      // 加载页面数据的方法
      var that = this;
    }
  },
  methods: {
    getParams() {
      var that = this;
    },
    //这里是获取登录状态
    getdengluzt: function () {
      var that = this;
      that.zrctoken = store.state.zrctoken;
      console.log('这里是获取登录状态that.zrctoken' + that.zrctoken);
      if (that.zrctoken.length > 0)
        //正常获取到了token
        {
          var url = U({
            m: 'zrcwebapi/user',
            c: 'webuser_api',
            a: 'getuserinfo'
          }, URL);
          var data = {
            zrctoken: that.$data.zrctoken
          };
          baseTokenPost(that.$data.zrctoken, url, data, function (res) {
            that.userinfo = res.data.info.userinfo;
            that.get_huiyuan_data(); //获取指定会员的配置
          }, function (res) {
            router.push({
              path: '/login'
            });
          });
        } else
        //没有登录的
        {
          router.push({
            path: '/login'
          });
        }
    },
    //获取指定项目的信息
    get_huiyuan_data: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi/user',
        c: 'webuser_api',
        a: 'huiyuan_data'
      }, URL);
      var data = {
        zrctoken: that.$data.zrctoken
      };
      baseTokenPost(that.$data.zrctoken, url, data, function (res) {
        that.chongzhi_list = res.data.info.chongzhi_list; //充值明细列表
        that.koufei_list = res.data.info.koufei_list; //消费明细列表
        that.dingdan_list = res.data.info.dingdan_list; //订单列表
        // that.weixianlist = res.data.info.weixianlist; //危险类型
        // that.yiqishebeilist = res.data.info.yiqishebeilist; //仪器类型
        // that.zhuangtailist = res.data.info.zhuangtailist; //状态类型
        // that.hourlist = res.data.info.hourlist; //小时类型
        // that.ceshimingxilist = res.data.info.ceshimingxilist; //测试项目
        // that.huishoutypelist = res.data.info.huishoutypelist; //样品回收里类型
        // that.quyangtypelist = res.data.info.quyangtypelist; //样品送样类型
        // that.quyangzhutilist = res.data.info.quyangzhutilist; //取样地址类型
        // that.dingdanlist = res.data.info.dingdanlist; //订单列表

        // that.dingdaninfo.shiyan_lianxiren_name = res.data.info.shiyan_lianxiren_name; //实验联系人
        // that.dingdaninfo.shiyan_lianxiren_tel = res.data.info.shiyan_lianxiren_tel; //实验联系电话
      }, function (res) {
        Tips(res.msg, 'warning');
      });
    },
    //这里是理解立即退出
    lijituichu: function () {
      var that = this;
      that.zrctoken = store.state.zrctoken;
      if (that.zrctoken.length > 0)
        //正常获取到了token
        {
          var url = U({
            m: 'zrcwebapi/user',
            c: 'webuser_api',
            a: 'goout'
          }, URL);
          var data = {};
          baseTokenPost(that.$data.zrctoken, url, data, function (res) {
            Tips('退出成功', 'success');
            store.commit('SetZrctoken', '');
            router.push({
              path: '/login'
            });
          });
        }
    },
    //切换菜单类型
    qiehuanmenu: function (rwtktype) {
      var that = this;
      that.current = rwtktype;
    }
  },
  mounted: function () {
    var that = this;
    that.getdengluzt();
  }
};